import React, { useEffect, useState, Component } from 'react';
import { motion } from 'framer-motion';
function setCookie(name: string, value: string, days: number) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  // Check if already logged in via cookie
  useEffect(() => {
    const session = getCookie('awc_session');
    if (session) {
      window.location.href = '/modulo-0';
    }
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !password.trim()) {
      setError('Todos los campos son obligatorios.');
      return;
    }
    setLoading(true);
    const users = JSON.parse(localStorage.getItem('awc_users') || '[]');
    const user = users.find((u: {
      email: string;
      password: string;
    }) => u.email === email.toLowerCase().trim() && u.password === password);
    if (!user) {
      setError('Correo electrónico o contraseña incorrectos.');
      setLoading(false);
      return;
    }
    // Set cookie for 365 days
    const sessionData = JSON.stringify({
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      loggedInAt: new Date().toISOString()
    });
    setCookie('awc_session', sessionData, 365);
    // Redirect to module 0
    setTimeout(() => {
      window.location.href = '/modulo-0';
    }, 500);
  };
  return <div className="flex min-h-screen items-center justify-center bg-[#0a0a0a] px-4 py-12 font-body" data-id="element-917">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4
    }} className="w-full max-w-[440px]" data-id="element-918">
        {/* Logo */}
        <div className="mb-10 text-center" data-id="element-919">
          <a href="/" className="inline-block font-heading text-[15px] font-black tracking-[3px] text-white uppercase" data-id="element-920">
            AI <span className="text-[#F5C842]" data-id="element-921">WEB CLOSER</span>
          </a>
          <div className="mt-2 text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-922">
            Accede a tu cuenta
          </div>
        </div>

        {/* Card */}
        <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-923">
          <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-6 py-3.5" data-id="element-924">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-925"></div>
            <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-926">
              Iniciar Sesión
            </div>
          </div>

          <form onSubmit={handleSubmit} className="px-6 py-6" data-id="element-927">
            {error && <div className="mb-4 rounded-r-lg border border-[#3a1a1a] border-l-[3px] border-l-[#ff6b6b] bg-[#1a0a0a] px-4 py-3 text-[12px] text-[#ff6b6b]" data-id="element-928">
                {error}
              </div>}

            <div className="mb-4" data-id="element-929">
              <label className="mb-1.5 block text-[11px] font-bold tracking-[1px] text-[#555] uppercase" data-id="element-930">
                Correo Electrónico
              </label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="tu@email.com" className="w-full rounded-md border border-[#1e1e1e] bg-[#0a0a0a] px-4 py-3 text-[13px] text-white placeholder-[#333] outline-none transition-colors focus:border-[#F5C842]" data-id="element-931" />
            </div>

            <div className="mb-6" data-id="element-932">
              <label className="mb-1.5 block text-[11px] font-bold tracking-[1px] text-[#555] uppercase" data-id="element-933">
                Contraseña
              </label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Tu contraseña" className="w-full rounded-md border border-[#1e1e1e] bg-[#0a0a0a] px-4 py-3 text-[13px] text-white placeholder-[#333] outline-none transition-colors focus:border-[#F5C842]" data-id="element-934" />
            </div>

            <button type="submit" disabled={loading} className="w-full rounded-md bg-[#F5C842] px-6 py-3.5 font-heading text-[12px] font-black tracking-[1px] text-black uppercase transition-opacity hover:opacity-90 disabled:opacity-50" data-id="element-935">
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
          </form>
        </div>

        {/* Signup link */}
        <div className="mt-6 text-center text-[12px] text-[#555]" data-id="element-936">
          ¿No tienes cuenta?{' '}
          <a href="/checkout" className="font-bold text-[#F5C842] transition-colors hover:text-white" data-id="element-937">
            Crear Cuenta
          </a>
        </div>
      </motion.div>
    </div>;
}